import { render, staticRenderFns } from "./Biller.vue?vue&type=template&id=64c8f1d1"
import script from "./Biller.vue?vue&type=script&lang=js"
export * from "./Biller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports